import {
  ACTIVO_USERS_DELETE,
  CLEAR_ALL,
  GETALL_USERS_DELETE,
  LOADING_GETALL_USERS_DELETE,
  PARAMS_USERS_DELETE,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const usersDeleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_USERS_DELETE:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_USERS_DELETE:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_USERS_DELETE:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_USERS_DELETE:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
